import React from 'react';
import styles from './Checkbox.scss';

interface CheckboxProps {
    /**Unique id of the component */
    id: string;
    /**Label that appears on the right of the checkbox */
    labelSlot: React.ReactNode | string;
    value?: boolean;
    disabled?: boolean;
    onChange?: (value: boolean) => void;
}

const Checkbox = ({ id, labelSlot, value, onChange, disabled }: CheckboxProps) => {

    return (
        <div className={styles.checkbox}>
            <input
                id={id}
                checked={value}
                className={styles.checkbox__input}
                type="checkbox"
                onChange={(e) => {
                    if (onChange) {
                        onChange(e.target.checked)
                    }
                }}
                disabled={disabled}
            />
            <label htmlFor={id} className={styles.checkbox__label}>{labelSlot}</label>
        </div>
    )
};

export default Checkbox;
